<template>
  <div>
    <b-card no-body>
      <b-tabs small card justified>
        <div>
          
          <pre v-if="results.downSpeed">
Download: {{results.downSpeed}} Mbits/s
Upload: {{results.upSpeed}} Mbits/s
Router IP/ISP: {{results.client_IP}} / {{results.client_ISP}}
Speedtest Server: {{results.server_ISP}} ({{results.server_name}}) 
Latency (ping): {{results.latency}} ms 
Distance: {{results.server_distance}} mi

          </pre>

        </div>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  components: {

  },
  props: {
    deviceID: '',
    results: {
        type: Object,
        default: function() {
          return {}
        }

    },
  },
  data() {
    return {
    }
  },

  methods: {
  },
};
</script>


<!-- msg='{ "head": { "reqID": "1773", "op": "speedTest", "mac": "20769352ECA0", "serial": "20769352ECA0", "model": "WR1200", "firmware_versionID": "RN-WR1200 1.0.18-1a", "ragent_ver": "1.0.11", "uptime": 10482 }, "data": { "results": { "client_IP": "182.237.8.69", "client_ISP": "GTPL Broadband", "downSpeed": "38.11", "upSpeed": "17.64", "server_name": "Ahmedabad", "server_ISP": "GTPL Broadband Pvt Ltd", "server_distance": "0.48" } }  -->
